import { createActions, createReducer } from 'reduxsauce';
import * as Immutable from 'seamless-immutable';
import * as R from 'ramda';

/* ------------- Types and Action Creators ------------- */
const tag = '[SAGA_SETTING_REDUX]'; // eslint-disable-line

const functionDefinitions = {

    /*---------- updatePropAndProjectSettings --------*/

    requestUpdatePropAndProjectSettings: ['propAndProjectSettingUpdate'],
    updatePropAndProjectSettingsSuccess: ['updatePropAndProjectSettingsResponse'],
    updatePropAndProjectSettingsFailure: ['updatePropAndProjectSettingsError'],

    /*---------- getSalesCommissionSetting --------*/

    requestGetSalesCommissionSetting: [],
    getSalesCommissionSettingSuccess: ['getSalesCommissionSettingResponse'],
    getSalesCommissionSettingFailure: ['getSalesCommissionSettingError'],


    /*---------- updateSalesCommissionSetting --------*/

    requestUpdateSalesCommissionSetting: ['salesCommissiontSettingUpdate', 'userId'],
    updateSalesCommissionSuccess: ['updateSalesCommissionSettingResponse'],
    updateSalesCommissionFailure: ['updateSalesCommissionSettingError'],

    /*---------- getAllPropAndProjectSettings --------*/

    requestGetAllPropAndProjectSettings: ['settingCommon'],
    getAllPropAndProjectSettingsSuccess: ['getAllPropAndProjectSettingsResponse'],
    getAllPropAndProjectSettingsFailure: ['getAllPropAndProjectSettingsError'],

    /*---------- updateDropdownOptionSettings --------*/

    requestUpdateDropdownOptionSettings: ['dropdownSettingUpdate'],
    updateDropdownOptionSettingsSuccess: ['updateDropdownOptionSettingsResponse'],
    updateDropdownOptionSettingsFailure: ['updateDropdownOptionSettingsError'],

    /*---------- getEnquirySettings --------*/

    requestGetEnquirySettings: ['settingCommon'],
    getEnquirySettingsSuccess: ['getEnquirySettingsResponse'],
    getEnquirySettingsFailure: ['getEnquirySettingsError'],

    /*---------- updateDocumentTemplate --------*/

    requestUpdateDocumentTemplate: ['documentTemplateUpdate'],
    updateDocumentTemplateSuccess: ['updateDocumentTemplateResponse'],
    updateDocumentTemplateFailure: ['updateDocumentTemplateError'],

    /*---------- getMultiLanguage --------*/

    requestGetMultiLanguage: [],
    getMultiLanguageSuccess: ['getMultiLanguageResponse'],
    getMultiLanguageFailure: ['getMultiLanguageError'],

    /*---------- getOfficeSettingLanguage --------*/

    requestGetOfficeSettingLanguage: [],
    getOfficeSettingLanguageSuccess: ['getOfficeSettingLanguageResponse'],
    getOfficeSettingLanguageFailure: ['getOfficeSettingLanguageError'],

    /*---------- updateDefaultOfficeLanguage --------*/

    requestUpdateDefaultOfficeLanguage: ['id'],
    updateDefaultOfficeLanguageSuccess: ['updateDefaultOfficeLanguageResponse'],
    updateDefaultOfficeLanguageFailure: ['updateDefaultOfficeLanguageError'],

    /*---------- deleteLanguageOfficeMapping --------*/
    requestDeleteLanguageOfficeMapping: ['langId'],
    deleteLanguageOfficeMappingSuccess: ['deleteLanguageOfficeMappingResponse'],
    deleteLanguageOfficeMappingFailure: ['deleteLanguageOfficeMappingError'],

    /*---------- createLanguageOfficeMapping --------*/

    requestCreateLanguageOfficeMapping: ['langId'],
    createLanguageOfficeMappingSuccess: ['createLanguageOfficeMappingResponse'],
    createLanguageOfficeMappingFailure: ['createLanguageOfficeMappingError'],

    /*---------- getDefaultOfficeSettingLanguage --------*/

    requestGetDefaultOfficeSettingLanguage: [],
    getDefaultOfficeSettingLanguageSuccess: ['getDefaultOfficeSettingLanguageResponse'],
    getDefaultOfficeSettingLanguageFailure: ['getDefaultOfficeSettingLanguageError'],

    /*---------- getOfficeSettings --------*/
    requestGetOfficeSettings: [],
    getOfficeSettingsSuccess: ['getOfficeSettingsResponse'],
    getOfficeSettingsFailure: ['getOfficeSettingsError'],

    /*---------- updateOfficeDetail --------*/
    requestUpdateOfficeDetail: ['officeDetail'],
    updateOfficeDetailSuccess: ['updateOfficeDetailResponse'],
    updateOfficeDetailFailure: ['updateOfficeDetailError'],

    /*---------- updateOfficeBuyerCosts --------*/
    requestUpdateOfficeBuyerCosts: ['officeDetail'],
    updateOfficeBuyerCostsSuccess: ['updateOfficeBuyerCostsResponse'],
    updateOfficeBuyerCostsFailure: ['updateOfficeBuyerCostsError'],

    /*---------- updateOfficeFMR --------*/
    requestUpdateOfficeFMR: ['officeDetail'],
    updateOfficeFMRSuccess: ['updateOfficeFMRResponse'],
    updateOfficeFMRFailure: ['updateOfficeFMRError'],

    /*---------- updateOfficePortal --------*/
    requestUpdateOfficePortal: ['officePortal'],
    updateOfficePortalSuccess: ['updateOfficePortalResponse'],
    updateOfficePortalFailure: ['updateOfficePortalError'],

    /*---------- deleteOfficePortal --------*/
    requestDeleteOfficePortal: ['portalSenderId'],
    deleteOfficePortalSuccess: ['deleteOfficePortalResponse'],
    deleteOfficePortalFailure: ['deleteOfficePortalError'],

    /*---------- createOfficePortal --------*/
    requestCreateOfficePortal: ['portalSender'],
    createOfficePortalSuccess: ['createOfficePortalResponse'],
    createOfficePortalFailure: ['createOfficePortalError'],

    /*---------- updateOfficeDarkpool --------*/
    requestUpdateOfficeDarkpool: ['officeDetail'],
    updateOfficeDarkpoolSuccess: ['updateOfficeDarkpoolResponse'],
    updateOfficeDarkpoolFailure: ['updateOfficeDarkpoolError'],

    /*---------- getEmployees --------*/

    requestGetEmployees: [],
    getEmployeesSuccess: ['getEmployeesResponse'],
    getEmployeesFailure: ['getEmployeesError'],

    /*---------- getEmployeeDetail --------*/

    requestGetEmployeeDetail: ['userId'],
    getEmployeeDetailSuccess: ['getEmployeeDetailResponse'],
    getEmployeeDetailFailure: ['getEmployeeDetailError'],

    /*---------- saveEmployeeDetail --------*/

    requestSaveEmployeeDetail: ['employeeDetail'],
    saveEmployeeDetailSuccess: ['saveEmployeeDetailResponse'],
    saveEmployeeDetailFailure: ['saveEmployeeDetailError'],

    /*---------- saveEmployeeEducationDetail --------*/

    requestSaveEmployeeEducationDetail: ['usersEducations'],
    saveEmployeeEducationDetailSuccess: ['saveEmployeeEducationDetailResponse'],
    saveEmployeeEducationDetailFailure: ['saveEmployeeEducationDetailError'],

    /*---------- updatePropertiesOnWeb --------*/

    requestUpdatePropertiesOnWeb: ['userId'],
    updatePropertiesOnWebSuccess: ['updatePropertiesOnWebResponse'],
    updatePropertiesOnWebFailure: ['updatePropertiesOnWebError'],

    /*---------- autoGenerateUserName --------*/

    requestAutoGenerateUserName: [],
    autoGenerateUserNameSuccess: ['autoGenerateUserNameResponse'],
    autoGenerateUserNameFailure: ['autoGenerateUserNameError'],

    /*---------- updateEmployeeStatus --------*/

    requestUpdateEmployeeStatus: ['employeeStatus'],
    updateEmployeeStatusSuccess: ['updateEmployeeStatusResponse'],
    updateEmployeeStatusFailure: ['updateEmployeeStatusError'],

    /*---------- getEmployeeStatusProperties --------*/

    requestGetEmployeeStatusProperties: ['userId'],
    getEmployeeStatusPropertiesSuccess: ['getEmployeeStatusPropertiesResponse'],
    getEmployeeStatusPropertiesFailure: ['getEmployeeStatusPropertiesError'],

    /*---------- saveUserColumnSetting --------*/

    requestSaveUserColumnSetting: ['userId', 'settingType', 'selectedColumns'],
    saveUserColumnSettingSuccess: ['saveUserColumnSettingResponse'],
    saveUserColumnSettingFailure: ['saveUserColumnSettingError'],

    /*---------- updateUserDefaultList --------*/
    requestUpdateUserDefaultList: ['userId', 'defaultList'],
    updateUserDefaultListSuccess: ['updateUserDefaultListResponse'],
    updateUserDefaultListFailure: ['updateUserDefaultListError'],

};

const { Types, Creators } = createActions(functionDefinitions);

export const SagaSettingTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const SagaSettingInitState = {
    SettingDetail: [],
};

export const INITIAL_STATE = Immutable(SagaSettingInitState);

/* ------------- Reducers ------------- */

/*---------- getSalesCommissionSetting --------*/


export const requestGetSalesCommissionSetting = (state: Immutable, action) => {
    return state.merge(
        {
            getSalesCommissionSettingFetching: true,
            branchId: action.branchId,
        });
};
export const getSalesCommissionSettingSuccess = (state: Immutable, action) => {
    return state.merge(
        {
            getSalesCommissionSettingFetching: false,
            getSalesCommissionSettingResponse: action.getSalesCommissionSettingResponse,

        });
};
export const getSalesCommissionSettingFailure = (state: Immutable, action) => {
    return state.merge(
        {
            getSalesCommissionSettingFetching: false,
            getSalesCommissionSettingError: action.getSalesCommissionSettingError,

        });
};


/*---------- updateSalesCommissionSetting --------*/


export const requestUpdateSalesCommissionSetting = (state: Immutable, action) => {
    return state.merge(
        {
            updateSalesCommissionSettingFetching: true,
            salesCommissiontSettingUpdate: action.salesCommissiontSettingUpdate,
            updateSalesCommissionSettingError: null

        });
};
export const updateSalesCommissionSuccess = (state: Immutable, action) => {
    return state.merge(
        {
            updateSalesCommissionSettingFetching: false,
            updateSalesCommissionSettingResponse: action.updateSalesCommissionSettingResponse,
            updateSalesCommissionSettingError: null

        });
};
export const updateSalesCommissionFailure = (state: Immutable, action) => {
    return state.merge(
        {
            updateSalesCommissionSettingFetching: false,
            updateSalesCommissionSettingError: action.updateSalesCommissionSettingError,
            updateSalesCommissionSettingResponse: null

        });
};

/*---------- updatePropAndProjectSettings --------*/


export const requestUpdatePropAndProjectSettings = (state, action) => {
    return state.merge(
        {
            updatePropAndProjectSettingsFetching: true,
            propAndProjectSettingUpdate: action.propAndProjectSettingUpdate,
            updatePropAndProjectSettingsError: null,
            updatePropAndProjectSettingsResponse: null
        });
};
export const updatePropAndProjectSettingsSuccess = (state, action) => {
    return state.merge(
        {
            updatePropAndProjectSettingsFetching: false,
            updatePropAndProjectSettingsResponse: action.updatePropAndProjectSettingsResponse,
            updatePropAndProjectSettingsError: null
        });
};
export const updatePropAndProjectSettingsFailure = (state, action) => {
    return state.merge(
        {
            updatePropAndProjectSettingsFetching: false,
            updatePropAndProjectSettingsError: action.updatePropAndProjectSettingsError,

        });
};


/*---------- getAllPropAndProjectSettings --------*/


export const requestGetAllPropAndProjectSettings = (state, action) => {
    return state.merge(
        {
            getAllPropAndProjectSettingsFetching: true,
            settingCommon: action.settingCommon,

        });
};
export const getAllPropAndProjectSettingsSuccess = (state, action) => {
    return state.merge(
        {
            getAllPropAndProjectSettingsFetching: false,
            getAllPropAndProjectSettingsResponse: action.getAllPropAndProjectSettingsResponse,

        });
};
export const getAllPropAndProjectSettingsFailure = (state, action) => {
    return state.merge(
        {
            getAllPropAndProjectSettingsFetching: false,
            getAllPropAndProjectSettingsError: action.getAllPropAndProjectSettingsError,

        });
};

/*---------- updateDropdownOptionSettings --------*/


export const requestUpdateDropdownOptionSettings = (state, action) => {
    return state.merge(
        {
            updateDropdownOptionSettingsFetching: true,
            dropdownSettingUpdate: action.dropdownSettingUpdate,

        });
};
export const updateDropdownOptionSettingsSuccess = (state, action) => {
    return state.merge(
        {
            updateDropdownOptionSettingsFetching: false,
            updateDropdownOptionSettingsResponse: action.updateDropdownOptionSettingsResponse,

        });
};
export const updateDropdownOptionSettingsFailure = (state, action) => {
    return state.merge(
        {
            updateDropdownOptionSettingsFetching: false,
            updateDropdownOptionSettingsError: action.updateDropdownOptionSettingsError,

        });
};


/*---------- getEnquirySettings --------*/


export const requestGetEnquirySettings = (state, action) => {
    return state.merge(
        {
            getEnquirySettingsFetching: true,
            settingCommon: action.settingCommon,
            getEnquirySettingsResponse: null,
        });
};
export const getEnquirySettingsSuccess = (state, action) => {
    return state.merge(
        {
            getEnquirySettingsFetching: false,
            getEnquirySettingsResponse: action.getEnquirySettingsResponse,
            getEnquirySettingsError: null
        });
};
export const getEnquirySettingsFailure = (state, action) => {
    return state.merge(
        {
            getEnquirySettingsFetching: false,
            getEnquirySettingsError: action.getEnquirySettingsError,
        });
};

/*---------- updateDocumentTemplate --------*/


export const requestUpdateDocumentTemplate = (state, action) => {
    return state.merge(
        {
            updateDocumentTemplateFetching: true,
            documentTemplateUpdate: action.documentTemplateUpdate,
            updateDocumentTemplateError: null

        });
};
export const updateDocumentTemplateSuccess = (state, action) => {
    return state.merge(
        {
            updateDocumentTemplateFetching: false,
            updateDocumentTemplateResponse: action.updateDocumentTemplateResponse,
            updateDocumentTemplateError: null
        });
};
export const updateDocumentTemplateFailure = (state, action) => {
    return state.merge(
        {
            updateDocumentTemplateFetching: false,
            updateDocumentTemplateError: action.updateDocumentTemplateError,

        });
};

/*---------- getMultiLanguage --------*/


export const requestGetMultiLanguage = (state) => {
    return state.merge(
        {
            getMultiLanguageFetching: true,
            getMultiLanguageError: null,
        });
};
export const getMultiLanguageSuccess = (state: Immutable, action) => {
    return state.merge(
        {
            getMultiLanguageFetching: false,
            getMultiLanguageResponse: action.getMultiLanguageResponse,
            getMultiLanguageError: null
        });
};
export const getMultiLanguageFailure = (state, action) => {
    return state.merge(
        {
            getMultiLanguageFetching: false,
            getMultiLanguageError: action.getMultiLanguageError,
        });
};


/*---------- getOfficeSettingLanguage --------*/


export const requestGetOfficeSettingLanguage = (state) => {
    return state.merge(
        {
            getOfficeSettingLanguageFetching: true,
            getOfficeSettingLanguageError: null
        });
};
export const getOfficeSettingLanguageSuccess = (state, action) => {
    return state.merge(
        {
            getOfficeSettingLanguageFetching: false,
            getOfficeSettingLanguageResponse: action.getOfficeSettingLanguageResponse,
            getOfficeSettingLanguageError: null
        });
};
export const getOfficeSettingLanguageFailure = (state, action) => {
    return state.merge(
        {
            getOfficeSettingLanguageFetching: false,
            getOfficeSettingLanguageError: action.getOfficeSettingLanguageError,

        });
};

/*---------- updateDefaultOfficeLanguage --------*/


export const requestUpdateDefaultOfficeLanguage = (state, action) => {
    return state.merge(
        {
            updateDefaultOfficeLanguageFetching: true,
            id: action.id,
            updateDefaultOfficeLanguageError: null
        });
};
export const updateDefaultOfficeLanguageSuccess = (state, action) => {
    return state.merge(
        {
            updateDefaultOfficeLanguageFetching: false,
            updateDefaultOfficeLanguageResponse: action.updateDefaultOfficeLanguageResponse,
            updateDefaultOfficeLanguageError: null
        });
};
export const updateDefaultOfficeLanguageFailure = (state, action) => {
    return state.merge(
        {
            updateDefaultOfficeLanguageFetching: false,
            updateDefaultOfficeLanguageError: action.updateDefaultOfficeLanguageError,

        });
};

/*---------- deleteLanguageOfficeMapping --------*/


export const requestDeleteLanguageOfficeMapping = (state, action) => {
    return state.merge(
        {
            deleteLanguageOfficeMappingFetching: true,
            langId: action.langId,
            deleteLanguageOfficeMappingResponse: null,
            deleteLanguageOfficeMappingError: null,
        });
};
export const deleteLanguageOfficeMappingSuccess = (state, action) => {
    return state.merge(
        {
            deleteLanguageOfficeMappingFetching: false,
            deleteLanguageOfficeMappingResponse: action.deleteLanguageOfficeMappingResponse,
            deleteLanguageOfficeMappingError: null,
        });
};
export const deleteLanguageOfficeMappingFailure = (state, action) => {
    return state.merge(
        {
            deleteLanguageOfficeMappingFetching: false,
            deleteLanguageOfficeMappingError: action.deleteLanguageOfficeMappingError,
        });
};

/*---------- createLanguageOfficeMapping --------*/


export const requestCreateLanguageOfficeMapping = (state, action) => {
    return state.merge(
        {
            createLanguageOfficeMappingFetching: true,
            langId: action.langId,
            createLanguageOfficeMappingResponse: null,
            createLanguageOfficeMappingError: null
        });
};
export const createLanguageOfficeMappingSuccess = (state, action) => {
    return state.merge(
        {
            createLanguageOfficeMappingFetching: false,
            createLanguageOfficeMappingResponse: action.createLanguageOfficeMappingResponse,
        });
};
export const createLanguageOfficeMappingFailure = (state, action) => {
    return state.merge(
        {
            createLanguageOfficeMappingFetching: false,
            createLanguageOfficeMappingError: action.createLanguageOfficeMappingError,
        });
};

/*---------- getDefaultOfficeSettingLanguage --------*/

export const requestGetDefaultOfficeSettingLanguage = (state) => {
    return state.merge(
        {
            getDefaultOfficeSettingLanguageFetching: true,
            getDefaultOfficeSettingLanguageResponse: null,
            getDefaultOfficeSettingLanguageError: null,
        });
};
export const getDefaultOfficeSettingLanguageSuccess = (state, action) => {
    return state.merge(
        {
            getDefaultOfficeSettingLanguageFetching: false,
            getDefaultOfficeSettingLanguageResponse: action.getDefaultOfficeSettingLanguageResponse,
        });
};
export const getDefaultOfficeSettingLanguageFailure = (state, action) => {
    return state.merge(
        {
            getDefaultOfficeSettingLanguageFetching: false,
            getDefaultOfficeSettingLanguageError: action.getDefaultOfficeSettingLanguageError,
        });
};

/*---------- getEmployees --------*/


export const requestGetEmployees = (state) => {
    return state.merge(
        {
            getEmployeesFetching: true,
            getEmployeesResponse: null,
            getEmployeesError: null,
        });
};
export const getEmployeesSuccess = (state, action) => {
    return state.merge(
        {
            getEmployeesFetching: false,
            getEmployeesResponse: action.getEmployeesResponse,

        });
};
export const getEmployeesFailure = (state, action) => {
    return state.merge(
        {
            getEmployeesFetching: false,
            getEmployeesError: action.getEmployeesError,

        });
};


/*---------- getOfficeSettings --------*/
export const requestGetOfficeSettings = (state) => {
    return state.merge(
        {
            getOfficeSettingsFetching: true,
            getOfficeSettingsResponse: null,
            getOfficeSettingsError: null,
            // update office master detail
            updateOfficeDetailError: null,
            updateOfficeDetailResponse: null,
            // update buyer costs
            updateOfficeBuyerCostsResponse: null,
            updateOfficeBuyerCostsError: null,
            // update fmr
            updateOfficeFMRResponse: null,
            updateOfficeFMRError: null,
            // update portal
            updateOfficePortalResponse: null,
            updateOfficePortalError: null,
            // remove portal
            deleteOfficePortalResponse: null,
            deleteOfficePortalError: null,
            // add portal
            createOfficePortalResponse: null,
            createOfficePortalError: null,
            // update darkpool
            updateOfficeDarkpoolResponse: null,
            updateOfficeDarkpoolError: null
        });
};
export const getOfficeSettingsSuccess = (state, action) => {
    return state.merge(
        {
            getOfficeSettingsFetching: false,
            getOfficeSettingsResponse: action.getOfficeSettingsResponse,
        });
};
export const getOfficeSettingsFailure = (state, action) => {
    return state.merge(
        {
            getOfficeSettingsFetching: false,
            getOfficeSettingsError: action.getOfficeSettingsError,
        });
};

/*---------- updateOfficeDetail --------*/
export const requestUpdateOfficeDetail = (state, action) => {
    return state.merge(
        {
            updateOfficeDetailFetching: true,
            officeDetail: action.officeDetail,
            updateOfficeDetailResponse: null,
            updateOfficeDetailError: null,
        });
};
export const updateOfficeDetailSuccess = (state, action) => {
    return state.merge(
        {
            updateOfficeDetailFetching: false,
            updateOfficeDetailResponse: action.updateOfficeDetailResponse,
            getOfficeSettingsResponse: action.updateOfficeDetailResponse,
            updateOfficeDetailError: null,
        });
};
export const updateOfficeDetailFailure = (state, action) => {
    return state.merge(
        {
            updateOfficeDetailFetching: false,
            updateOfficeDetailError: action.updateOfficeDetailError,
            updateOfficeDetailResponse: null,
        });
};

/*---------- updateOfficeBuyerCosts --------*/
export const requestUpdateOfficeBuyerCosts = (state, action) => {
    return state.merge(
        {
            updateOfficeBuyerCostsFetching: true,
            officeDetail: action.officeDetail,
            updateOfficeBuyerCostsResponse: null,
            updateOfficeBuyerCostsError: null
        });
};
export const updateOfficeBuyerCostsSuccess = (state, action) => {
    return state.merge(
        {
            updateOfficeBuyerCostsFetching: false,
            updateOfficeBuyerCostsResponse: action.updateOfficeBuyerCostsResponse,
            getOfficeSettingsResponse: action.updateOfficeBuyerCostsResponse,
            updateOfficeBuyerCostsError: null
        });
};
export const updateOfficeBuyerCostsFailure = (state, action) => {
    return state.merge(
        {
            updateOfficeBuyerCostsFetching: false,
            updateOfficeBuyerCostsError: action.updateOfficeBuyerCostsError,
        });
};

/*---------- updateOfficeFMR --------*/
export const requestUpdateOfficeFMR = (state, action) => {
    return state.merge(
        {
            updateOfficeFMRFetching: true,
            officeDetail: action.officeDetail,
            updateOfficeFMRResponse: null,
            updateOfficeFMRError: null
        });
};
export const updateOfficeFMRSuccess = (state, action) => {
    return state.merge(
        {
            updateOfficeFMRFetching: false,
            updateOfficeFMRResponse: action.updateOfficeFMRResponse,
            getOfficeSettingsResponse: action.updateOfficeFMRResponse,
            updateOfficeFMRError: null,
        });
};
export const updateOfficeFMRFailure = (state, action) => {
    return state.merge(
        {
            updateOfficeFMRFetching: false,
            updateOfficeFMRError: action.updateOfficeFMRError,
        });
};

/*---------- updateOfficePortal --------*/
export const requestUpdateOfficePortal = (state, action) => {
    return state.merge(
        {
            updateOfficePortalFetching: true,
            officePortal: action.officePortal,
            updateOfficePortalResponse: null,
            updateOfficePortalError: null,
        });
};
export const updateOfficePortalSuccess = (state, action) => {
    return state.merge(
        {
            updateOfficePortalFetching: false,
            updateOfficePortalResponse: action.updateOfficePortalResponse,
            getOfficeSettingsResponse: action.updateOfficePortalResponse,
        });
};
export const updateOfficePortalFailure = (state, action) => {
    return state.merge(
        {
            updateOfficePortalFetching: false,
            updateOfficePortalError: action.updateOfficePortalError,
        });
};

/*---------- deleteOfficePortal --------*/
export const requestDeleteOfficePortal = (state, action) => {
    return state.merge(
        {
            deleteOfficePortalFetching: true,
            portalSenderId: action.portalSenderId,
            deleteOfficePortalResponse: null,
            deleteOfficePortalError: null,
        });
};
export const deleteOfficePortalSuccess = (state, action) => {
    return state.merge(
        {
            deleteOfficePortalFetching: false,
            deleteOfficePortalResponse: action.deleteOfficePortalResponse,
            getOfficeSettingsResponse: action.deleteOfficePortalResponse,
        });
};
export const deleteOfficePortalFailure = (state, action) => {
    return state.merge(
        {
            deleteOfficePortalFetching: false,
            deleteOfficePortalError: action.deleteOfficePortalError,
        });
};

/*---------- createOfficePortal --------*/
export const requestCreateOfficePortal = (state, action) => {
    return state.merge(
        {
            createOfficePortalFetching: true,
            portalSender: action.portalSender,
            createOfficePortalResponse: null,
            createOfficePortalError: null
        });
};
export const createOfficePortalSuccess = (state, action) => {
    return state.merge(
        {
            createOfficePortalFetching: false,
            createOfficePortalResponse: action.createOfficePortalResponse,
            getOfficeSettingsResponse: action.createOfficePortalResponse,
        });
};
export const createOfficePortalFailure = (state, action) => {
    return state.merge(
        {
            createOfficePortalFetching: false,
            createOfficePortalError: action.createOfficePortalError,
        });
};

/*---------- updateOfficeDarkpool --------*/
export const requestUpdateOfficeDarkpool = (state, action) => {
    return state.merge(
        {
            updateOfficeDarkpoolFetching: true,
            officeDetail: action.officeDetail,
            updateOfficeDarkpoolResponse: null,
            updateOfficeDarkpoolError: null
        });
};
export const updateOfficeDarkpoolSuccess = (state, action) => {
    return state.merge(
        {
            updateOfficeDarkpoolFetching: false,
            updateOfficeDarkpoolResponse: action.updateOfficeDarkpoolResponse,
            getOfficeSettingsResponse: action.updateOfficeDarkpoolResponse,
        });
};
export const updateOfficeDarkpoolFailure = (state, action) => {
    return state.merge(
        {
            updateOfficeDarkpoolFetching: false,
            updateOfficeDarkpoolError: action.updateOfficeDarkpoolError,
        });
};

/*---------- getEmployeeDetail --------*/


export const requestGetEmployeeDetail = (state, action) => {
    return state.merge(
        {
            getEmployeeDetailFetching: true,
            userId: action.userId,
            getEmployeeDetailResponse: null,
            getEmployeeDetailError: null,
            //   saveEmployeeEducationDetailFetching: false,
            saveEmployeeDetailFetching: false,
            saveEmployeeDetailError: null,
            saveEmployeeEducationDetailError: null,
            updatePropertiesOnWebError: null,
            updateEmployeeStatusError: null,
        });
};
export const getEmployeeDetailSuccess = (state, action) => {
    return state.merge(
        {
            getEmployeeDetailFetching: false,
            getEmployeeDetailResponse: action.getEmployeeDetailResponse,

        });
};
export const getEmployeeDetailFailure = (state, action) => {
    return state.merge(
        {
            getEmployeeDetailFetching: false,
            getEmployeeDetailError: action.getEmployeeDetailError,

        });
};

/*---------- saveEmployeeDetail --------*/


export const requestSaveEmployeeDetail = (state, action) => {
    return state.merge(
        {
            saveEmployeeDetailFetching: true,
            employeeDetail: action.employeeDetail,
            saveEmployeeDetailResponse: null,
            saveEmployeeDetailError: null,
        });
};
export const saveEmployeeDetailSuccess = (state, action) => {
    return state.merge(
        {
            saveEmployeeDetailFetching: false,
            saveEmployeeDetailResponse: action.saveEmployeeDetailResponse
        });
};
export const saveEmployeeDetailFailure = (state, action) => {
    return state.merge(
        {
            saveEmployeeDetailFetching: false,
            saveEmployeeDetailError: action.saveEmployeeDetailError,

        });
};



/*---------- saveEmployeeEducationDetail --------*/


export const requestSaveEmployeeEducationDetail = (state, action) => {
    return state.merge(
        {
            saveEmployeeEducationDetailFetching: true,
            usersEducations: action.usersEducations,
            saveEmployeeEducationDetailResponse: null,
            saveEmployeeEducationDetailError: null,

        });
};
export const saveEmployeeEducationDetailSuccess = (state, action) => {
    return state.merge(
        {
            saveEmployeeEducationDetailFetching: false,
            saveEmployeeEducationDetailResponse: action.saveEmployeeEducationDetailResponse,

        });
};
export const saveEmployeeEducationDetailFailure = (state, action) => {
    return state.merge(
        {
            saveEmployeeEducationDetailFetching: false,
            saveEmployeeEducationDetailError: action.saveEmployeeEducationDetailError,

        });
};

/*---------- updatePropertiesOnWeb --------*/


export const requestUpdatePropertiesOnWeb = (state, action) => {
    return state.merge(
        {
            updatePropertiesOnWebFetching: true,
            userId: action.userId,
            updatePropertiesOnWebResponse: null,
            updatePropertiesOnWebError: null
        });
};
export const updatePropertiesOnWebSuccess = (state, action) => {
    return state.merge(
        {
            updatePropertiesOnWebFetching: false,
            updatePropertiesOnWebResponse: action.updatePropertiesOnWebResponse,

        });
};
export const updatePropertiesOnWebFailure = (state, action) => {
    return state.merge(
        {
            updatePropertiesOnWebFetching: false,
            updatePropertiesOnWebError: action.updatePropertiesOnWebError,

        });
};


/*---------- autoGenerateUserName --------*/


export const requestAutoGenerateUserName = (state) => {
    return state.merge(
        {
            autoGenerateUserNameFetching: true,
            autoGenerateUserNameResponse: null,
            autoGenerateUserNameError: null,
        });
};
export const autoGenerateUserNameSuccess = (state, action) => {
    return state.merge(
        {
            autoGenerateUserNameFetching: false,
            autoGenerateUserNameResponse: action.autoGenerateUserNameResponse,

        });
};
export const autoGenerateUserNameFailure = (state, action) => {
    return state.merge(
        {
            autoGenerateUserNameFetching: false,
            autoGenerateUserNameError: action.autoGenerateUserNameError,

        });
};


/*---------- updateEmployeeStatus --------*/


export const requestUpdateEmployeeStatus = (state, action) => {
    return state.merge(
        {
            updateEmployeeStatusFetching: true,
            employeeStatus: action.employeeStatus,
            updateEmployeeStatusResponse: null,
            updateEmployeeStatusError: null
        });
};
export const updateEmployeeStatusSuccess = (state, action) => {
    return state.merge(
        {
            updateEmployeeStatusFetching: false,
            updateEmployeeStatusResponse: action.updateEmployeeStatusResponse,
        });
};
export const updateEmployeeStatusFailure = (state, action) => {
    return state.merge(
        {
            updateEmployeeStatusFetching: false,
            updateEmployeeStatusError: action.updateEmployeeStatusError,
        });
};



/*---------- getEmployeeStatusProperties --------*/


export const requestGetEmployeeStatusProperties = (state, action) => {
    return state.merge(
        {
            getEmployeeStatusPropertiesFetching: true,
            userId: action.userId,
            getEmployeeStatusPropertiesResponse: null,
            getEmployeeStatusPropertiesError: null,

        });
};
export const getEmployeeStatusPropertiesSuccess = (state, action) => {
    return state.merge(
        {
            getEmployeeStatusPropertiesFetching: false,
            getEmployeeStatusPropertiesResponse: action.getEmployeeStatusPropertiesResponse,

        });
};
export const getEmployeeStatusPropertiesFailure = (state, action) => {
    return state.merge(
        {
            getEmployeeStatusPropertiesFetching: false,
            getEmployeeStatusPropertiesError: action.getEmployeeStatusPropertiesError,

        });
};

/*---------- saveUserColumnSetting --------*/
export const requestSaveUserColumnSetting = (state, action) => {
    return state.merge(
        {
            saveUserColumnSettingFetching: true,
            userId: action.userId,
            settingType: action.settingType,
            selectedColumns: action.selectedColumns
        });
};
export const saveUserColumnSettingSuccess = (state, action) => {
    return state.merge(
        {
            saveUserColumnSettingFetching: false,
            saveUserColumnSettingResponse: action.saveUserColumnSettingResponse
        });
};
export const saveUserColumnSettingFailure = (state, action) => {
    return state.merge(
        {
            saveUserColumnSettingFetching: false,
            saveUserColumnSettingError: action.saveUserColumnSettingError
        });
};

/*---------- updateUserDefaultList --------*/
export const requestUpdateUserDefaultList = (state, action) => {
    return state.merge(
        {
            updateUserDefaultListFetching: true,
            userId: action.userId,
            defaultList: action.defaultList,
        });
};
export const updateUserDefaultListSuccess = (state, action) => {
    return state.merge(
        {
            updateUserDefaultListFetching: false,
            updateUserDefaultListResponse: action.updateUserDefaultListResponse,
        });
};
export const updateUserDefaultListFailure = (state, action) => {
    return state.merge(
        {
            updateUserDefaultListFetching: false,
            updateUserDefaultListError: action.updateUserDefaultListError,
        });
};


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {


    /*---------- getSalesCommissionSetting --------*/

    [Types.REQUEST_GET_SALES_COMMISSION_SETTING]: requestGetSalesCommissionSetting,
    [Types.GET_SALES_COMMISSION_SETTING_SUCCESS]: getSalesCommissionSettingSuccess,
    [Types.GET_SALES_COMMISSION_SETTING_FAILURE]: getSalesCommissionSettingFailure,


    /*---------- updateSalesCommissionSetting --------*/

    [Types.REQUEST_UPDATE_SALES_COMMISSION_SETTING]: requestUpdateSalesCommissionSetting,
    [Types.UPDATE_SALES_COMMISSION_SUCCESS]: updateSalesCommissionSuccess,
    [Types.UPDATE_SALES_COMMISSION_FAILURE]: updateSalesCommissionFailure,

    /*---------- updatePropAndProjectSettings --------*/

    [Types.REQUEST_UPDATE_PROP_AND_PROJECT_SETTINGS]: requestUpdatePropAndProjectSettings,
    [Types.UPDATE_PROP_AND_PROJECT_SETTINGS_SUCCESS]: updatePropAndProjectSettingsSuccess,
    [Types.UPDATE_PROP_AND_PROJECT_SETTINGS_FAILURE]: updatePropAndProjectSettingsFailure,


    /*---------- getAllPropAndProjectSettings --------*/

    [Types.REQUEST_GET_ALL_PROP_AND_PROJECT_SETTINGS]: requestGetAllPropAndProjectSettings,
    [Types.GET_ALL_PROP_AND_PROJECT_SETTINGS_SUCCESS]: getAllPropAndProjectSettingsSuccess,
    [Types.GET_ALL_PROP_AND_PROJECT_SETTINGS_FAILURE]: getAllPropAndProjectSettingsFailure,


    /*---------- updateDropdownOptionSettings --------*/

    [Types.REQUEST_UPDATE_DROPDOWN_OPTION_SETTINGS]: requestUpdateDropdownOptionSettings,
    [Types.UPDATE_DROPDOWN_OPTION_SETTINGS_SUCCESS]: updateDropdownOptionSettingsSuccess,
    [Types.UPDATE_DROPDOWN_OPTION_SETTINGS_FAILURE]: updateDropdownOptionSettingsFailure,


    /*---------- getEnquirySettings --------*/

    [Types.REQUEST_GET_ENQUIRY_SETTINGS]: requestGetEnquirySettings,
    [Types.GET_ENQUIRY_SETTINGS_SUCCESS]: getEnquirySettingsSuccess,
    [Types.GET_ENQUIRY_SETTINGS_FAILURE]: getEnquirySettingsFailure,

    /*---------- updateDocumentTemplate --------*/

    [Types.REQUEST_UPDATE_DOCUMENT_TEMPLATE]: requestUpdateDocumentTemplate,
    [Types.UPDATE_DOCUMENT_TEMPLATE_SUCCESS]: updateDocumentTemplateSuccess,
    [Types.UPDATE_DOCUMENT_TEMPLATE_FAILURE]: updateDocumentTemplateFailure,


    /*---------- getMultiLanguage --------*/

    [Types.REQUEST_GET_MULTI_LANGUAGE]: requestGetMultiLanguage,
    [Types.GET_MULTI_LANGUAGE_SUCCESS]: getMultiLanguageSuccess,
    [Types.GET_MULTI_LANGUAGE_FAILURE]: getMultiLanguageFailure,

    /*---------- getOfficeSettingLanguage --------*/

    [Types.REQUEST_GET_OFFICE_SETTING_LANGUAGE]: requestGetOfficeSettingLanguage,
    [Types.GET_OFFICE_SETTING_LANGUAGE_SUCCESS]: getOfficeSettingLanguageSuccess,
    [Types.GET_OFFICE_SETTING_LANGUAGE_FAILURE]: getOfficeSettingLanguageFailure,

    /*---------- updateDefaultOfficeLanguage --------*/

    [Types.REQUEST_UPDATE_DEFAULT_OFFICE_LANGUAGE]: requestUpdateDefaultOfficeLanguage,
    [Types.UPDATE_DEFAULT_OFFICE_LANGUAGE_SUCCESS]: updateDefaultOfficeLanguageSuccess,
    [Types.UPDATE_DEFAULT_OFFICE_LANGUAGE_FAILURE]: updateDefaultOfficeLanguageFailure,

    /*---------- deleteLanguageOfficeMapping --------*/

    [Types.REQUEST_DELETE_LANGUAGE_OFFICE_MAPPING]: requestDeleteLanguageOfficeMapping,
    [Types.DELETE_LANGUAGE_OFFICE_MAPPING_SUCCESS]: deleteLanguageOfficeMappingSuccess,
    [Types.DELETE_LANGUAGE_OFFICE_MAPPING_FAILURE]: deleteLanguageOfficeMappingFailure,

    /*---------- createLanguageOfficeMapping --------*/

    [Types.REQUEST_CREATE_LANGUAGE_OFFICE_MAPPING]: requestCreateLanguageOfficeMapping,
    [Types.CREATE_LANGUAGE_OFFICE_MAPPING_SUCCESS]: createLanguageOfficeMappingSuccess,
    [Types.CREATE_LANGUAGE_OFFICE_MAPPING_FAILURE]: createLanguageOfficeMappingFailure,

    /*---------- getDefaultOfficeSettingLanguage --------*/

    [Types.REQUEST_GET_DEFAULT_OFFICE_SETTING_LANGUAGE]: requestGetDefaultOfficeSettingLanguage,
    [Types.GET_DEFAULT_OFFICE_SETTING_LANGUAGE_SUCCESS]: getDefaultOfficeSettingLanguageSuccess,
    [Types.GET_DEFAULT_OFFICE_SETTING_LANGUAGE_FAILURE]: getDefaultOfficeSettingLanguageFailure,

    /*---------- getOfficeSettings --------*/
    [Types.REQUEST_GET_OFFICE_SETTINGS]: requestGetOfficeSettings,
    [Types.GET_OFFICE_SETTINGS_SUCCESS]: getOfficeSettingsSuccess,
    [Types.GET_OFFICE_SETTINGS_FAILURE]: getOfficeSettingsFailure,

    /*---------- updateOfficeDetail --------*/
    [Types.REQUEST_UPDATE_OFFICE_DETAIL]: requestUpdateOfficeDetail,
    [Types.UPDATE_OFFICE_DETAIL_SUCCESS]: updateOfficeDetailSuccess,
    [Types.UPDATE_OFFICE_DETAIL_FAILURE]: updateOfficeDetailFailure,

    /*---------- updateOfficeBuyerCosts --------*/
    [Types.REQUEST_UPDATE_OFFICE_BUYER_COSTS]: requestUpdateOfficeBuyerCosts,
    [Types.UPDATE_OFFICE_BUYER_COSTS_SUCCESS]: updateOfficeBuyerCostsSuccess,
    [Types.UPDATE_OFFICE_BUYER_COSTS_FAILURE]: updateOfficeBuyerCostsFailure,

    /*---------- updateOfficeFMR --------*/
    [Types.REQUEST_UPDATE_OFFICE_F_M_R]: requestUpdateOfficeFMR,
    [Types.UPDATE_OFFICE_F_M_R_SUCCESS]: updateOfficeFMRSuccess,
    [Types.UPDATE_OFFICE_F_M_R_FAILURE]: updateOfficeFMRFailure,

    /*---------- updateOfficePortal --------*/
    [Types.REQUEST_UPDATE_OFFICE_PORTAL]: requestUpdateOfficePortal,
    [Types.UPDATE_OFFICE_PORTAL_SUCCESS]: updateOfficePortalSuccess,
    [Types.UPDATE_OFFICE_PORTAL_FAILURE]: updateOfficePortalFailure,

    /*---------- deleteOfficePortal --------*/
    [Types.REQUEST_DELETE_OFFICE_PORTAL]: requestDeleteOfficePortal,
    [Types.DELETE_OFFICE_PORTAL_SUCCESS]: deleteOfficePortalSuccess,
    [Types.DELETE_OFFICE_PORTAL_FAILURE]: deleteOfficePortalFailure,

    /*---------- createOfficePortal --------*/
    [Types.REQUEST_CREATE_OFFICE_PORTAL]: requestCreateOfficePortal,
    [Types.CREATE_OFFICE_PORTAL_SUCCESS]: createOfficePortalSuccess,
    [Types.CREATE_OFFICE_PORTAL_FAILURE]: createOfficePortalFailure,

    /*---------- updateOfficeDarkpool --------*/
    [Types.REQUEST_UPDATE_OFFICE_DARKPOOL]: requestUpdateOfficeDarkpool,
    [Types.UPDATE_OFFICE_DARKPOOL_SUCCESS]: updateOfficeDarkpoolSuccess,
    [Types.UPDATE_OFFICE_DARKPOOL_FAILURE]: updateOfficeDarkpoolFailure,

    /*---------- getEmployees --------*/

    [Types.REQUEST_GET_EMPLOYEES]: requestGetEmployees,
    [Types.GET_EMPLOYEES_SUCCESS]: getEmployeesSuccess,
    [Types.GET_EMPLOYEES_FAILURE]: getEmployeesFailure,

    /*---------- getEmployeeDetail --------*/

    [Types.REQUEST_GET_EMPLOYEE_DETAIL]: requestGetEmployeeDetail,
    [Types.GET_EMPLOYEE_DETAIL_SUCCESS]: getEmployeeDetailSuccess,
    [Types.GET_EMPLOYEE_DETAIL_FAILURE]: getEmployeeDetailFailure,

    /*---------- saveEmployeeDetail --------*/

    [Types.REQUEST_SAVE_EMPLOYEE_DETAIL]: requestSaveEmployeeDetail,
    [Types.SAVE_EMPLOYEE_DETAIL_SUCCESS]: saveEmployeeDetailSuccess,
    [Types.SAVE_EMPLOYEE_DETAIL_FAILURE]: saveEmployeeDetailFailure,

    /*---------- saveEmployeeEducationDetail --------*/

    [Types.REQUEST_SAVE_EMPLOYEE_EDUCATION_DETAIL]: requestSaveEmployeeEducationDetail,
    [Types.SAVE_EMPLOYEE_EDUCATION_DETAIL_SUCCESS]: saveEmployeeEducationDetailSuccess,
    [Types.SAVE_EMPLOYEE_EDUCATION_DETAIL_FAILURE]: saveEmployeeEducationDetailFailure,

    /*---------- updatePropertiesOnWeb --------*/

    [Types.REQUEST_UPDATE_PROPERTIES_ON_WEB]: requestUpdatePropertiesOnWeb,
    [Types.UPDATE_PROPERTIES_ON_WEB_SUCCESS]: updatePropertiesOnWebSuccess,
    [Types.UPDATE_PROPERTIES_ON_WEB_FAILURE]: updatePropertiesOnWebFailure,

    /*---------- autoGenerateUserName --------*/

    [Types.REQUEST_AUTO_GENERATE_USER_NAME]: requestAutoGenerateUserName,
    [Types.AUTO_GENERATE_USER_NAME_SUCCESS]: autoGenerateUserNameSuccess,
    [Types.AUTO_GENERATE_USER_NAME_FAILURE]: autoGenerateUserNameFailure,

    /*---------- updateEmployeeStatus --------*/

    [Types.REQUEST_UPDATE_EMPLOYEE_STATUS]: requestUpdateEmployeeStatus,
    [Types.UPDATE_EMPLOYEE_STATUS_SUCCESS]: updateEmployeeStatusSuccess,
    [Types.UPDATE_EMPLOYEE_STATUS_FAILURE]: updateEmployeeStatusFailure,

    /*---------- getEmployeeStatusProperties --------*/

    [Types.REQUEST_GET_EMPLOYEE_STATUS_PROPERTIES]: requestGetEmployeeStatusProperties,
    [Types.GET_EMPLOYEE_STATUS_PROPERTIES_SUCCESS]: getEmployeeStatusPropertiesSuccess,
    [Types.GET_EMPLOYEE_STATUS_PROPERTIES_FAILURE]: getEmployeeStatusPropertiesFailure,

    /*---------- saveUserColumnSetting --------*/
    [Types.REQUEST_SAVE_USER_COLUMN_SETTING]: requestSaveUserColumnSetting,
    [Types.SAVE_USER_COLUMN_SETTING_SUCCESS]: saveUserColumnSettingSuccess,
    [Types.SAVE_USER_COLUMN_SETTING_FAILURE]: saveUserColumnSettingFailure,

    /*---------- updateUserDefaultList --------*/

    [Types.REQUEST_UPDATE_USER_DEFAULT_LIST]: requestUpdateUserDefaultList,
    [Types.UPDATE_USER_DEFAULT_LIST_SUCCESS]: updateUserDefaultListSuccess,
    [Types.UPDATE_USER_DEFAULT_LIST_FAILURE]: updateUserDefaultListFailure,
});


// WEBPACK FOOTER //
// ./src/redux/sagaSetting/sagaSettingRedux.ts